import React, { FC } from 'react';
import { useLocation } from 'react-router-dom';
import classNames from 'classnames';

import ProgressBar from 'components/ProgressBar';

import { ReactComponent as Arrow } from 'assets/images/arrow.svg';

interface Props {
    logoUrl: string;
    isHiddenProgress?: boolean;
    handleSwitchToPrevScreen?: () => void;
    lengthOnboarding?: number;
    logoLink: string;
}

const Header: FC<Props> = ({ logoUrl, isHiddenProgress, handleSwitchToPrevScreen, lengthOnboarding = 0, logoLink }) => {
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const quizScreenFromUrl = Number(params.get('screen'));

    const headerClassNames = classNames('header', {
        'header--flex': !isHiddenProgress,
    });

    return (
        <header className={headerClassNames}>
            <a href={logoLink} target="_blank" className="header__logo" rel="noreferrer">
                <img src={logoUrl} alt="logo" />
            </a>
            {!isHiddenProgress && (
                <div className="header__wraper">
                    <button type="button" className="header__button" onClick={handleSwitchToPrevScreen}>
                        <Arrow className="header__icon" />
                        Back
                    </button>
                    <ProgressBar total={lengthOnboarding} activeScreen={quizScreenFromUrl} />
                </div>
            )}
            <div />
        </header>
    );
};

export default Header;
